import { Language } from '../enums/language';
import { DashboardJobStatus } from '../enums/DashboardJobStatus';

export class Dashboard {
    id: string;
    name: string;
    alernatingInterval: number;
    fitBoundsToHighlightedRoute: boolean;
    jobs: DashboardRoute[];
    url: string;
    language: Language;
    logo: string;
    whiteLogoBackground: boolean;

    constructor();
    constructor(json: any, baseUrl: string);
    constructor(json?: Dashboard, baseUrl?: string) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.alernatingInterval = json.alernatingInterval;
            this.fitBoundsToHighlightedRoute = json.fitBoundsToHighlightedRoute;
            this.jobs = json.jobs;
            this.language = json.language;
            this.logo = json.logo;
            this.whiteLogoBackground = json.whiteLogoBackground || false;

            if (baseUrl) {
                this.url = baseUrl + json.id;
            }
        } else {
            this.jobs = [];
            this.fitBoundsToHighlightedRoute = false;
        }
    }
}

export class DashboardRoute {
    id: string;
    name: string;
    minimumDelay: number;
    status: DashboardJobStatus;

    constructor();
    constructor(json: any);
    constructor(json?: DashboardRoute) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.minimumDelay = json.minimumDelay;
            this.status = json.status;
        }
    }
}

export class CreateUpdateDashboardModel {
    public id: string;
    public name: string;
    public alernatingInterval: number;
    public fitBoundsToHighlightedRoute: boolean;
    public jobs: DashboardRoute[];
    public url: string;
    public language: Language;
    public Base64: string;
    public whiteLogoBackground: boolean;

    constructor() { };
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/dashboard.ts